import {TypeNatureMarcheChoix} from './TypeNatureMarcheChoix';
import { TypeObjCPVFNSSimple } from './TypeObjCPVFNSSimple';
export class TypeFNSSimpleDescMarche2 {

	public description: string;

	public criteresAttrib: string;

	public intitule: string;

	public codeCPV: TypeObjCPVFNSSimple;

	public natureMarche: TypeNatureMarcheChoix;

	constructor() {
		this.description = '';
		this.criteresAttrib = '';
		this.intitule = '';
		this.codeCPV = new TypeObjCPVFNSSimple();
		this.natureMarche = new TypeNatureMarcheChoix();

	}
}
